
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/analytics-ai-automation",
      function () {
        return require("private-next-pages/services/analytics-ai-automation.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/analytics-ai-automation"])
      });
    }
  